import {
  SetArticleQuantityBody,
  SetArticleQuantityBodyV2,
  SetSavingsPlanArticleBody,
} from '@zooplus/checkout-state';

import { ARTICLE_TYPE, CART_VERSION } from './constants';

export const restoreArticle = (
  runMutations: {
    setSavingsPlanArticle?: Function;
    setArticleQuantity?: Function;
  },
  trackReAddItemEvent: Function,
  isArticleSp?: string | boolean | null,
  articleId?: string | number | null,
  offerIds?: string[] | null,
  cartApiVersion?: string,
) => {
  const { setSavingsPlanArticle, setArticleQuantity } = runMutations;
  const payload: SetArticleQuantityBody | SetSavingsPlanArticleBody = {
    articleId: Number(articleId),
    quantity: 1,
  };
  if (cartApiVersion === CART_VERSION.V2 && offerIds?.length) {
    (payload as SetArticleQuantityBodyV2).offerIds = offerIds;
  }
  if (isArticleSp && JSON.stringify(isArticleSp) === 'true') {
    trackReAddItemEvent(Number(articleId), ARTICLE_TYPE.SAVINGS_PLAN);
    setSavingsPlanArticle && setSavingsPlanArticle(payload);
  } else {
    trackReAddItemEvent(Number(articleId), ARTICLE_TYPE.STANDARD);
    setArticleQuantity && setArticleQuantity(payload);
  }
};
